import { publicTripPath } from '@lib/publicLinks'
import { TripOverviewSection } from './types'

/**
 * The public identity of each bento section: the `/shared/trips/:code/<segment>`
 * URL segment (note `money → expenses`) and the backend detail `endpoint`, which
 * doubles as the react-query cache-key prefix. Routes, share links, hooks, and
 * query keys all derive from this record.
 */
export const PUBLIC_SECTIONS: Record<TripOverviewSection, { segment: string; endpoint: string }> = {
	itinerary: { segment: 'itinerary', endpoint: 'public-itinerary' },
	ideas: { segment: 'ideas', endpoint: 'public-ideas' },
	accommodations: { segment: 'accommodations', endpoint: 'public-accommodations' },
	flights: { segment: 'flights', endpoint: 'public-flights' },
	files: { segment: 'files', endpoint: 'public-files' },
	money: { segment: 'expenses', endpoint: 'public-expenses' },
}

/** Section → public URL segment, derived from {@link PUBLIC_SECTIONS}. */
export const PUBLIC_SECTION_SEGMENTS: Record<TripOverviewSection, string> = Object.fromEntries(
	Object.entries(PUBLIC_SECTIONS).map(([section, { segment }]) => [section, segment]),
) as Record<TripOverviewSection, string>

/** The public route path for a bento section of the given trip code. */
export const publicSectionPath = (tripCode: string, section: TripOverviewSection): string =>
	`${publicTripPath(tripCode)}/${PUBLIC_SECTIONS[section].segment}`
